import React, { useEffect, useState } from 'react';
import './CheckBoxFieldComponent.scss';
import { FormField } from '../types';
import { Form } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
type LinkFieldComponentProps = {
  data?: FormField;
  onChange?: (data: string) => void;
  disabled?: boolean;
};
export const LinkFieldComponent = ({ data, disabled, onChange }: LinkFieldComponentProps) => {
  const { slug } = useParams();
  const [checkboxData, setCheckBoxData] = useState<string>();
  useEffect(() => {
    if (data) {
      setCheckBoxData(data.fieldValue ? data.fieldValue : []);
    }
  }, [data]);
  const onCheckBoxChange = () => {
    setCheckBoxData(data?.fieldValue ? '' : 'true');
    onChange && onChange(data?.fieldValue ? '' : 'true');
  };
  return (
    <div
      className={`checkbox-field pt-3 ${data?.options && data?.options.length > 3 ? 'wrap' : ''}`}
    >
      <div className="pet-row pl-2">
        <div className="p-checkbox-group p-pl-30">
          <>
            <label className="container-1">
              <Form.Check
                value={'true'}
                inline
                key={`checkbox-${data?.fieldName.trim().toLowerCase()}`}
                type="checkbox"
                name={`checkbox-${data?.fieldName.trim().toLowerCase()}`}
                disabled={disabled}
                onChange={onCheckBoxChange}
                checked={data?.fieldValue === 'true' ? true : false}
                className={data?.fieldValue ? '' : 'empty'}
              />
              <label className="terms-check" htmlFor="terms">
                I agree to the{' '}
                <a
                  href={window.location.origin + '/' + slug + '/terms'}
                  target="_blank"
                  rel="noreferrer"
                  className={disabled ? 'pointer-events-none' : ''}
                >
                  Terms and Conditions
                </a>
                .
              </label>
            </label>
          </>
        </div>
      </div>
    </div>
  );
};
